/* tslint:disable */
/* eslint-disable */
/**
 * Melco Assets APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AssetsMelcoModelsCustomWarning,
    AssetsMelcoModelsCustomWarningFromJSON,
    AssetsMelcoModelsCustomWarningFromJSONTyped,
    AssetsMelcoModelsCustomWarningToJSON,
    AssetsMelcoModelsThreadChartColor,
    AssetsMelcoModelsThreadChartColorFromJSON,
    AssetsMelcoModelsThreadChartColorFromJSONTyped,
    AssetsMelcoModelsThreadChartColorToJSON,
    AssetsMelcoModelsThreadChartProduct,
    AssetsMelcoModelsThreadChartProductFromJSON,
    AssetsMelcoModelsThreadChartProductFromJSONTyped,
    AssetsMelcoModelsThreadChartProductToJSON,
} from './';

/**
 * 
 * @export
 * @interface AssetsMelcoModelsSyncThreadChart
 */
export interface AssetsMelcoModelsSyncThreadChart {
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsSyncThreadChart
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsSyncThreadChart
     */
    file_name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AssetsMelcoModelsSyncThreadChart
     */
    version?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AssetsMelcoModelsSyncThreadChart
     */
    skip_download?: boolean;
    /**
     * 
     * @type {Array<AssetsMelcoModelsThreadChartColor>}
     * @memberof AssetsMelcoModelsSyncThreadChart
     */
    thread_chart_color_list?: Array<AssetsMelcoModelsThreadChartColor> | null;
    /**
     * 
     * @type {Array<AssetsMelcoModelsThreadChartProduct>}
     * @memberof AssetsMelcoModelsSyncThreadChart
     */
    product_list?: Array<AssetsMelcoModelsThreadChartProduct> | null;
    /**
     * 
     * @type {number}
     * @memberof AssetsMelcoModelsSyncThreadChart
     */
    publish_state?: number;
    /**
     * 
     * @type {Date}
     * @memberof AssetsMelcoModelsSyncThreadChart
     */
    created_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof AssetsMelcoModelsSyncThreadChart
     */
    publish_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof AssetsMelcoModelsSyncThreadChart
     */
    updated_date?: Date | null;
    /**
     * 
     * @type {Array<AssetsMelcoModelsCustomWarning>}
     * @memberof AssetsMelcoModelsSyncThreadChart
     */
    warning_list?: Array<AssetsMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsSyncThreadChart
     */
    signature?: string | null;
}

export function AssetsMelcoModelsSyncThreadChartFromJSON(json: any): AssetsMelcoModelsSyncThreadChart {
    return AssetsMelcoModelsSyncThreadChartFromJSONTyped(json, false);
}

export function AssetsMelcoModelsSyncThreadChartFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetsMelcoModelsSyncThreadChart {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'file_name': !exists(json, 'file_name') ? undefined : json['file_name'],
        'version': !exists(json, 'version') ? undefined : json['version'],
        'skip_download': !exists(json, 'skip_download') ? undefined : json['skip_download'],
        'thread_chart_color_list': !exists(json, 'thread_chart_color_list') ? undefined : (json['thread_chart_color_list'] === null ? null : (json['thread_chart_color_list'] as Array<any>).map(AssetsMelcoModelsThreadChartColorFromJSON)),
        'product_list': !exists(json, 'product_list') ? undefined : (json['product_list'] === null ? null : (json['product_list'] as Array<any>).map(AssetsMelcoModelsThreadChartProductFromJSON)),
        'publish_state': !exists(json, 'publish_state') ? undefined : json['publish_state'],
        'created_date': !exists(json, 'created_date') ? undefined : (new Date(json['created_date'])),
        'publish_date': !exists(json, 'publish_date') ? undefined : (json['publish_date'] === null ? null : new Date(json['publish_date'])),
        'updated_date': !exists(json, 'updated_date') ? undefined : (json['updated_date'] === null ? null : new Date(json['updated_date'])),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(AssetsMelcoModelsCustomWarningFromJSON)),
        'signature': !exists(json, 'signature') ? undefined : json['signature'],
    };
}

export function AssetsMelcoModelsSyncThreadChartToJSON(value?: AssetsMelcoModelsSyncThreadChart | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'file_name': value.file_name,
        'version': value.version,
        'skip_download': value.skip_download,
        'thread_chart_color_list': value.thread_chart_color_list === undefined ? undefined : (value.thread_chart_color_list === null ? null : (value.thread_chart_color_list as Array<any>).map(AssetsMelcoModelsThreadChartColorToJSON)),
        'product_list': value.product_list === undefined ? undefined : (value.product_list === null ? null : (value.product_list as Array<any>).map(AssetsMelcoModelsThreadChartProductToJSON)),
        'publish_state': value.publish_state,
        'created_date': value.created_date === undefined ? undefined : (value.created_date.toISOString()),
        'publish_date': value.publish_date === undefined ? undefined : (value.publish_date === null ? null : value.publish_date.toISOString()),
        'updated_date': value.updated_date === undefined ? undefined : (value.updated_date === null ? null : value.updated_date.toISOString()),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(AssetsMelcoModelsCustomWarningToJSON)),
        'signature': value.signature,
    };
}


